<template>
    <section id="missionstatement" class="wrapper style3" :style="{ backgroundImage: 'url(' + this.missionStatement.backgroundImg + ')' }">
        <div class="inner">
            <header class="align-center">
                <p v-html="missionStatement.missionText"></p>
                <h2>{{missionStatement.title}}</h2>
            </header>
        </div>
    </section>
</template>

<script>
export default {
    props : {
        missionStatement : Object
    }
}
</script>

<style scoped>

</style>